import React, { useState, useRef, useCallback } from 'react';
import { AssetItem } from './AssetItem';
import { IRecordMap } from '../../../../store/modules/report/i-report';
import { useStore } from '../../../../store';

type CustomLazyListProps = {
  items: IRecordMap[];
  loading: boolean;
  type?:'selected' | 'notSelected'
};

export const LazyList: React.FC<CustomLazyListProps> = ({
  items = [], loading, type,
}): JSX.Element => {
  const {

    mapReport,

  } = useStore();

  const [visibleItemsCount, setVisibleItemsCount] = useState(50); // Initial items to load
  const observer = useRef<IntersectionObserver | null>(null);
  // Callback to handle when the last item in the list becomes visible
  const lastItemRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setVisibleItemsCount((prevCount) => prevCount + 10); // Load more items in chunks of 10
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading],
  );

  return (
    <>
      {type && items.length ? (
        <div style={{ fontSize: '16px', fontWeight: 600, padding: '16px 16px 16px 16px' }}>
          {type === 'selected' ? 'Group selected' : 'Not selected'}
        </div>
      ) : null}
      {
        (!Object.values(mapReport.data.recordsMap).length)
          ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px',
              gap: '8px',
              marginTop: '50%',
            }}
            >
              <svg width="115" height="114" viewBox="0 0 115 114" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10.5" y="7" width="65" height="90" rx="5" fill="#D0D3D9" />
                <rect x="7.5" y="9" width="65" height="90" rx="5" fill="#E1E3E8" />
                <rect x="4.5" y="12" width="65" height="90" rx="5" fill="#F1F2F5" />
                <rect x="10.5" y="33" width="51" height="5" rx="2.5" fill="#E1E5EC" />
                <rect x="10.5" y="44" width="51" height="5" rx="2.5" fill="#E1E5EC" />
                <rect x="10.5" y="55" width="51" height="5" rx="2.5" fill="#E1E5EC" />
                <rect x="10.5" y="66" width="51" height="5" rx="2.5" fill="#E1E5EC" />
                <rect x="10.5" y="76" width="28" height="5" rx="2.5" fill="#E1E5EC" />
                <ellipse cx="66.5" cy="51.5" rx="19" ry="19.5" fill="#D9D9D9" fillOpacity="0.45" />
                <path fillRule="evenodd" clipRule="evenodd" d="M66.5566 69.9816C76.7943 69.9816 85.0936 61.6823 85.0936 51.4445C85.0936 41.2068 76.7943 32.9075 66.5566 32.9075C56.3189 32.9075 48.0195 41.2068 48.0195 51.4445C48.0195 61.6823 56.3189 69.9816 66.5566 69.9816ZM66.5566 76.7223C80.5171 76.7223 91.8344 65.4051 91.8344 51.4445C91.8344 37.484 80.5171 26.1667 66.5566 26.1667C52.5961 26.1667 41.2788 37.484 41.2788 51.4445C41.2788 65.4051 52.5961 76.7223 66.5566 76.7223Z" fill="#D0D3D9" />
                <path d="M85.8179 65.1465L100.392 78.9455L94.7319 84.9234L80.1579 71.1244L85.8179 65.1465Z" fill="#D0D3D9" />
                <path d="M91.1454 73.4142C93.0178 71.4844 96.1601 71.4961 98.1641 73.4403L110.244 85.1603C112.248 87.1046 112.354 90.2452 110.482 92.175L108.222 94.5045C106.349 96.4344 103.207 96.4227 101.203 94.4784L89.1234 82.7584C87.1195 80.8142 87.0128 77.6736 88.8852 75.7437L91.1454 73.4142Z" fill="#B5B8BF" />
              </svg>

              <span style={{ fontSize: '16px', color: '#0E0F12', fontWeight: 600 }}>No Results</span>
              <span style={{ fontSize: '14px', color: '#81848C', fontWeight: 400 }}>You not have assets yet</span>
            </div>
          )
          : (
            <div style={{ display: 'block', overflow: 'auto', minHeight: '200px' }}>
              {items.slice(0, visibleItemsCount).map((item, index) => {
                if (index === visibleItemsCount - 1) {
                  // Attach the observer to the last visible item
                  return (
                    <div ref={lastItemRef} key={item.uniqueKey || index}>
                      <AssetItem item={item} loading={loading} />
                    </div>
                  );
                }
                return (
                  <AssetItem
                    item={item}
                    key={item.uniqueKey || index}
                    loading={loading}
                  />
                );
              })}
            </div>
          )
      }
    </>

  );
};
